
const AuroraHero = () => {
    return (
        <div className={"starfield" + " static h-screen w-full overflow-hidden"}></div>

    );
};

export default AuroraHero;